import React from 'react';
import { BASE_TABS, DATA_TAB, QUICKBOOKS_TAB, ADMIN_TAB, DOC_LIBRARY_TAB } from './utils/settingsConstants';
import authService from '../../services/authService';
import { useSettingsData, useTabNavigation } from './hooks';
import { TabNavigation, SettingsContent } from './components';
import { useToast } from '../Toast';

/**
 * Main Settings component - orchestrates all settings functionality
 * Manages tab navigation, notifications, and settings data state
 */
const Settings = ({ userProfile }) => {
  const toast = useToast();
  const showNotification = (message, type = 'success') => {
    if (type === 'error') toast.error(message);
    else toast.success(message);
  };
  const { activeTab, setActiveTab } = useTabNavigation('general');
  const { qbSettings, loading, updateQbSettings, saveQuickBooksSettings } = useSettingsData(activeTab);

  const isAdmin = userProfile?.role === 'admin';
  const isAdminSession = isAdmin || authService.hasAdminReturn();

  let tabs;
  if (isAdmin) {
    tabs = [
      BASE_TABS[0], // General
      DATA_TAB,
      QUICKBOOKS_TAB,
      ADMIN_TAB,
      DOC_LIBRARY_TAB,
      ...BASE_TABS.slice(1) // Rest of the tabs
    ];
  } else {
    tabs = BASE_TABS;
  }

  const handleSaveQuickBooksSettings = async () => {
    return await saveQuickBooksSettings(showNotification);
  };

  return (
    <div className="p-4 md:p-6">
      {/* Desktop Layout */}
      <div className="hidden md:block mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Settings</h1>
        <p className="text-gray-600">Manage your application preferences and configuration</p>
      </div>

      {/* Mobile subtitle */}
      <div className="md:hidden mb-4">
        <p className="text-gray-600 text-xs">Manage your application preferences and configuration</p>
      </div>

      <div className="flex flex-col lg:flex-row gap-6">
        <TabNavigation 
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />

        <SettingsContent
          activeTab={activeTab}
          userProfile={userProfile}
          qbSettings={qbSettings}
          loading={loading}
          onQbSettingsChange={updateQbSettings}
          showNotification={showNotification}
          onSaveQuickBooksSettings={handleSaveQuickBooksSettings}
        />
      </div>
    </div>
  );
};

export default Settings;